'use strict'

module.exports = {
  repoVersion: 11
}
